<script>
import mixin from "@/pages/inspection_reports/forms/mixin";
import {router} from "@inertiajs/vue3";

export default {
  mixins: [mixin],
  props: {
    cylinders: {
      required: true,
    }
  },
  mounted() {
    this.CylindersAreBoundToUser(this.cylinders);
  },
  methods: {
    async CylindersAreBoundToUser(cylinders) {
      let requiredTypes = ['mixture_l', 'mixture_e', 'mixture_f', 'mixture_g'];
      let missingTypes = requiredTypes.filter(type => !cylinders.some(cylinder => cylinder.type === type));

      if (missingTypes.length > 0) {
        let confirmed = await Helpers.Alert.confirm('De benodigde cylinders zijn niet gekoppeld aan deze technicus');
        if (confirmed || !confirmed) {
          router.visit(route('cylinders.index'));
          return;
        }
      }

      return true;
    },
    isWithinMargin(testValue, inputValue, type, midTester) {
      if (!testValue || inputValue === null) {
        return false;
      }

      let margin;
      const parsedTestValue = parseFloat(testValue);
      const parsedInputValue = parseFloat(inputValue);

      switch (type) {
        case 'co':
          margin = Math.max(0.05 * parsedTestValue, 0.06);
          if (midTester) {
            margin = Math.max(0.05 * parsedTestValue, 0.03);
          }
          break;
        case 'co2':
          margin = Math.max(0.05 * parsedTestValue, 0.5);
          break;
        case 'o2':
          margin = Math.max(0.05 * parsedTestValue, 0.1);
          break;
        case 'ppm':
          margin = Math.max(0.05 * parsedTestValue, 12);
          if (midTester) {
            margin = Math.max(0.05 * parsedTestValue, 10);
          }
          break;
        default:
          Helpers.Message.error(`Onbekend type: ${type}`);
          return false;
      }

      return Math.abs(parsedTestValue - parsedInputValue) <= margin;
    },
    getGroups() {
      return [
        {
          'title': 'Algemene gegevens',
          'name': 'product',
          'component': 'default',
          'values': {
            'product_manufacturer': this.input({type: 'Default', label: 'Fabrikaat', value: this.getValue('product_manufacturer', this.customerProduct.product.manufacture.name)}),
            'product_type': this.input({type: 'Default', label: 'Type', value: this.getValue('product_type', this.customerProduct.product.type.name)}),
            'product_serie_nr': this.input({type: 'Default', label: 'Serienr.', value: this.getValue('product_serie_nr', this.customerProduct.product.serial_number)}),
            'product_toelatingsnr': this.input({type: 'Default', label: 'Toelatingsnr', value: this.getValue('product_toelatingsnr', this.customerProduct.product.type_approval_number)}),
          }
        },
        {
          'title': 'Plaats van opstelling',
          'name': 'customer',
          'component': 'hidden',
          'values': {
            'customer_naam': this.input({type: 'Default', label: 'Naam', value: this.getValue('customer_naam', this.customerProduct.customer.name)}),
            'customer_adres': this.input({type: 'Default', label: 'Adres', value: this.getValue('customer_adres', this.customerProduct.customer.address)}),
            'customer_plaats': this.input({type: 'Default', label: 'Plaats', value: this.getValue('customer_plaats', this.customerProduct.customer.city)}),
          }
        },
        {
          'title': 'Conformiteit',
          'name': 'conformiteit',
          'component': 'default',
          'values': {
            'conformiteit_software_versie': this.input({type: 'YesNo', label: `Softwareversie : ${this.softwareVersion}`, value: this.getValue('conformiteit_software_versie')}),
            'conformiteit_checksum': this.input({type: 'YesNo', label: `Checksum : ${this.checksum}`, value: this.getValue('conformiteit_checksum')}),
            'conformiteit_tellerstand': this.input({type: 'Default', label: 'Tellerstand voor / na / n.v.t', value: this.getValue('conformiteit_tellerstand')}),
            'conformiteit_debiet': this.input({type: 'YesNo', label: 'Debiet voldoende', value: this.getValue('conformiteit_debiet')}),
            'conformiteit_lektest': this.input({type: 'YesNo', label: 'Lowflow / lektest', value: this.getValue('conformiteit_lektest')}),
            'conformiteit_response_time_co': this.input({type: 'YesNo', label: 'Responstijd CO, CO2, HC < 15 sec. 95 % vol', value: this.getValue('conformiteit_response_time_co')}),
            'conformiteit_response_time_o2': this.input({type: 'YesNo', label: 'Responstijd O2 binnen 60 sec. < 0,1 % vol', value: this.getValue('conformiteit_response_time_o2')}),
          }
        },
        {
          'title': 'Algemeen',
          'name': 'common',
          'component': 'default',
          'values': {
            'common_verzegeling_onbeschadigd': this.input({type: 'YesNo', label: 'Verzegeling onbeschadigd', value: this.getValue('common_verzegeling_onbeschadigd')}),
            'common_omgevingstemperatuur': this.input({type: 'YesNo', label: 'Omgevingstemperatuur +5 tot 40 °C', value: this.getValue('common_omgevingstemperatuur')}),
            'common_nl_handleiding': this.input({type: 'YesNo', label: 'NL handleiding en NL opschriften', value: this.getValue('common_nl_handleiding')}),
            'common_opschriften': this.input({type: 'YesNo', label: 'NL opschriften / conformiteit', value: this.getValue('common_opschriften')}),
            'common_parts': this.input({type: 'YesNo', label: 'Alle losse onderdelen aanwezig', value: this.getValue('common_parts')}),
            'common_voeding': this.input({type: 'YesNo', label: 'Voedingsspanning', value: this.getValue('common_voeding')}),
            'common_electronische_mechanische_werking': this.input({type: 'YesNo', label: 'Electronische / mechanische werking', value: this.getValue('common_electronische_mechanische_werking')}),
            'common_optische_controle': this.input({type: 'YesNo', label: 'Optische controle olietemp. / rpm opnemer / slangen', value: this.getValue('common_optische_controle')}),
          }
        },
        {
          'title': 'Metingen: Mengsel L',
          'name': 'measurement_l',
          'component': 'default',
          'values': {
            'measurement_mixture_l_co': this.input({type: 'YesNoCalculateCylindersForm9', label: 'CO (%)', value: this.getValue('measurement_mixture_l_co'), cylinders: this.cylinders, callback: this.isWithinMargin}),
            'measurement_mixture_l_co2': this.input({type: 'YesNoCalculateCylindersForm9', label: 'CO2 (%)', value: this.getValue('measurement_mixture_l_co2'), cylinders: this.cylinders, callback: this.isWithinMargin}),
            'measurement_mixture_l_ppm': this.input({type: 'YesNoCalculateCylindersForm9', label: 'Prop (ppm)', value: this.getValue('measurement_mixture_l_ppm'), cylinders: this.cylinders, callback: this.isWithinMargin}),
          },
        },
        {
          'title': 'Metingen: Mengsel E',
          'name': 'measurement_e',
          'component': 'default',
          'values': {
            'measurement_mixture_e_co': this.input({type: 'YesNoCalculateCylindersForm9', label: 'CO (%)', value: this.getValue('measurement_mixture_e_co'), cylinders: this.cylinders, callback: this.isWithinMargin}),
            'measurement_mixture_e_co2': this.input({type: 'YesNoCalculateCylindersForm9', label: 'CO2 (%)', value: this.getValue('measurement_mixture_e_co2'), cylinders: this.cylinders, callback: this.isWithinMargin}),
            'measurement_mixture_e_ppm': this.input({type: 'YesNoCalculateCylindersForm9', label: 'Prop (ppm)', value: this.getValue('measurement_mixture_e_ppm'), cylinders: this.cylinders, callback: this.isWithinMargin}),
            'measurement_mixture_e_o2': this.input({type: 'YesNoCalculateCylindersForm9', label: 'O2 (%)', value: this.getValue('measurement_mixture_e_o2'), cylinders: this.cylinders, callback: this.isWithinMargin}),
          },
        },
        {
          'title': 'Metingen: Mengsel F',
          'name': 'measurement_f',
          'component': 'default',
          'values': {
            'measurement_mixture_f_co': this.input({type: 'YesNoCalculateCylindersForm9', label: 'CO (%)', value: this.getValue('measurement_mixture_f_co'), cylinders: this.cylinders, callback: this.isWithinMargin}),
            'measurement_mixture_f_co2': this.input({type: 'YesNoCalculateCylindersForm9', label: 'CO2 (%)', value: this.getValue('measurement_mixture_f_co2'), cylinders: this.cylinders, callback: this.isWithinMargin}),
            'measurement_mixture_f_ppm': this.input({type: 'YesNoCalculateCylindersForm9', label: 'Prop (ppm)', value: this.getValue('measurement_mixture_f_ppm'), cylinders: this.cylinders, callback: this.isWithinMargin}),
            'measurement_mixture_f_o2': this.input({type: 'YesNoCalculateCylindersForm9', label: 'O2 (%)', value: this.getValue('measurement_mixture_f_o2'), cylinders: this.cylinders, callback: this.isWithinMargin}),
          },
        },
        {
          'title': 'Metingen: Mengsel G',
          'name': 'measurement_g',
          'component': 'default',
          'values': {
            'measurement_mixture_g_co': this.input({type: 'YesNoCalculateCylindersForm9', label: 'CO (%)', value: this.getValue('measurement_mixture_g_co'), cylinders: this.cylinders, callback: this.isWithinMargin}),
            'measurement_mixture_g_co2': this.input({type: 'YesNoCalculateCylindersForm9', label: 'CO2 (%)', value: this.getValue('measurement_mixture_g_co2'), cylinders: this.cylinders, callback: this.isWithinMargin}),
            'measurement_mixture_g_ppm': this.input({type: 'YesNoCalculateCylindersForm9', label: 'Prop (ppm)', value: this.getValue('measurement_mixture_g_ppm'), cylinders: this.cylinders, callback: this.isWithinMargin}),
            'measurement_mixture_g_o2': this.input({type: 'YesNoCalculateCylindersForm9', label: 'O2 (%)', value: this.getValue('measurement_mixture_g_o2'), cylinders: this.cylinders, callback: this.isWithinMargin}),
          },
        },
        {
          'title': 'Bijzonderheden',
          'name': 'particularities',
          'component': 'default',
          'values': {
            'particularities_oxygen_cell_older_then_2_years': this.input({type: 'YesNo', label: 'Zuurstofcel ouder dan 2 jaar', value: this.getValue('particularities_oxygen_cell_older_then_2_years')}),
            'particularities_advice_replace_oxygen_cell': this.input({type: 'YesNo', label: 'Advies vervangen zuurstofcel', value: this.getValue('particularities_advice_replace_oxygen_cell')}),
          }
        },
        {
          'title': 'Omschrijving',
          'name': 'slot',
          'component': 'default',
          'values': {
            'slot_notes': this.input({type: 'textarea', label: 'Opmerkingen', value: this.getValue('common_notes')}),
          }
        }
      ]
    }
  }
}
</script>

<template>
  <FormRenderer
      ref="renderer"
      :inspectionReport="inspectionReport"
      :inspectionReportResponse="inspectionReportResponse"
      :customerProduct="customerProduct"
      :appointmentId="appointmentId"
  />
</template>